import {
  BrowserCacheLocation,
  Configuration,
} from '@azure/msal-browser';

import { environment } from 'src/environments/environment';

export const MSAL_AUTHORITIES = {
  default: environment.msal.authority,
};

export function getMsalConfig(): Configuration {
  return {
    auth: {
      authority: environment.msal.authority,
      clientId: environment.msal.clientId,
      navigateToLoginRequestUrl: true,
      redirectUri: environment.msal.redirectUri,
      knownAuthorities: [MSAL_AUTHORITIES.default],
    },
    cache: {
      claimsBasedCachingEnabled: true,
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      iframeHashTimeout: 3000,
      tokenRenewalOffsetSeconds: 60,
    },
  };
}
